export default __webpack_public_path__ + "static/media/alkr-logo.84cc4492.png";